"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultHitCount = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const context_1 = require("../../context");
const SearchResultHitCount = () => {
    const { resultCount, dictionary } = (0, context_1.useSearchResultContext)();
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex items-start flex-col mb-6 sm:mb-8 md:flex-row md:items-end md:justify-between", children: (0, jsx_runtime_1.jsxs)("div", { className: "list-total-count shrink-0", children: [dictionary === null || dictionary === void 0 ? void 0 : dictionary.numberOfItems, " (", resultCount || 0, ")"] }) }));
};
exports.SearchResultHitCount = SearchResultHitCount;
